import React from 'react';
import GetStarted from '../components/getStarted/GetStarted';

const Index = () => {
  return (
    <div>
      <GetStarted />
    </div>
  );
};

export default Index;
